// Footer hints — the legend after the action bar absorbed the combat keys
// (monorail-wuj). What remains: the non-combat keys and the music credit.
// Toggled with /.

import { GLYPHS, type GameButton } from '../game/controls'
import type { DeviceKind } from '../engine/input'

export interface Legend {
  toggle(): void
  /** Swap the rendered key glyphs to match the active device (Phase F,
   *  amoeba-input plan) — updates in place, no rebuild. */
  setDevice(d: DeviceKind): void
}

// Each entry has a real action id, so its bracketed key follows GLYPHS.
const ENTRIES: { id: GameButton; label: string }[] = [
  { id: 'interact', label: 'Home' },
  { id: 'stats', label: 'Specimen' },
  { id: 'autoFire', label: 'Reflex' },
  { id: 'legend', label: 'Hints' },
]

export function createLegend(): Legend {
  const el = document.getElementById('legend') as HTMLDivElement
  let visible = true

  const keyEls = ENTRIES.map(entry => {
    const span = document.createElement('span')
    const bracket = document.createElement('span')
    bracket.textContent = `[${GLYPHS[entry.id].kbm}]`
    span.appendChild(bracket)
    span.appendChild(document.createTextNode(` ${entry.label}`))
    el.appendChild(span)
    return bracket
  })

  // CC-BY attribution for sourced zone music — full record in
  // public/audio/music/CREDITS.md. Keyboard-only text, no action behind it.
  const credit = document.createElement('span')
  credit.style.opacity = '0.55'
  credit.textContent = '♪ Kevin MacLeod (incompetech.com) CC BY 4.0'
  el.appendChild(credit)

  return {
    toggle() {
      visible = !visible
      el.style.display = visible ? 'flex' : 'none'
    },
    setDevice(d) {
      for (let i = 0; i < ENTRIES.length; i++) {
        keyEls[i].textContent = `[${GLYPHS[ENTRIES[i].id][d]}]`
      }
    },
  }
}
